<template>
  <div v-if="total > 0" class="list-pagination">
    <el-pagination
      background
      small
      layout="total, sizes, prev, pager, next"
      :total="total"
      :page-size="pageSize"
      :current-page="page"
      :page-sizes="pageSizes"
      @size-change="$emit('size-change', $event)"
      @current-change="$emit('current-change', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'ListPagination',
  props: {
    total: { type: Number, default: 0 },
    page: { type: Number, default: 1 },
    pageSize: { type: Number, default: 15 },
    pageSizes: { type: Array, default: () => [10, 15, 20, 50] }
  }
}
</script>

<style scoped>
.list-pagination {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
</style>
